import { ServiceType } from '../domain/types';
import { useIntl } from '@/intl';

export function ServiceName({ type }: { type: string }) {
  const intl = useIntl();

  const serviceNames: Record<string, string> = {
    [ServiceType.CarRental]: intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_title' }),
    [ServiceType.CarRentalFiltering]: intl.formatMessage({
      id: 'checkout_steps_ancillaries_car_rental_filtering_title',
    }),
    [ServiceType.TravelInsurance]: intl.formatMessage({ id: 'checkout_steps_ancillaries_travel_insurance_title' }),
    [ServiceType.TravelInsurancePerBooking]: intl.formatMessage({
      id: 'checkout_steps_ancillaries_travel_insurance_title',
    }),
    [ServiceType.CancellationInsurance]: intl.formatMessage({
      id: 'checkout_steps_ancillaries_cancellation_insurance_title',
    }),
    [ServiceType.Transfer]: intl.formatMessage({ id: 'checkout_steps_ancillaries_transfer_title' }),
    [ServiceType.Visa]: intl.formatMessage({ id: 'checkout_steps_ancillaries_visa_title' }),
    [ServiceType.Rebooking]: intl.formatMessage({ id: 'checkout_steps_ancillaries_rebooking_title' }),
    [ServiceType.Babycot]: intl.formatMessage({ id: 'checkout_steps_ancillaries_babycot_title' }),
    [ServiceType.MealplanDP]: intl.formatMessage({ id: 'checkout_steps_ancillaries_mealplan_dp_title' }),
    [ServiceType.Mealplan]: intl.formatMessage({ id: 'checkout_steps_ancillaries_mealplan_title' }),
    [ServiceType.MealplanExternal]: intl.formatMessage({ id: 'checkout_steps_ancillaries_mealplan_external_title' }),
    [ServiceType.Breakfast]: intl.formatMessage({ id: 'checkout_steps_ancillaries_breakfast_title' }),
    [ServiceType.BreakfastArrivalBus]: intl.formatMessage({
      id: 'checkout_steps_ancillaries_breakfast_arrival_bus_title',
    }),
    [ServiceType.Dinner]: intl.formatMessage({ id: 'checkout_steps_ancillaries_dinner_title' }),
    [ServiceType.BookingRedeem]: intl.formatMessage({ id: 'checkout_steps_ancillaries_booking_redeemer_title' }),
    [ServiceType.Luggage]: intl.formatMessage({ id: 'checkout_steps_ancillaries_luggage_title' }),
    [ServiceType.DutchweekValThorens]: intl.formatMessage({
      id: 'checkout_steps_ancillaries_dutchweek_val_thorens_title',
    }),
    [ServiceType.Dutchweek]: intl.formatMessage({ id: 'checkout_steps_ancillaries_dutchweek_title' }),
    [ServiceType.Comedy]: intl.formatMessage({ id: 'checkout_steps_ancillaries_comedy_title' }),
    [ServiceType.ParkingAirport]: intl.formatMessage({ id: 'checkout_steps_ancillaries_parking_airport_title' }),
    [ServiceType.SkiTransfer]: intl.formatMessage({ id: 'checkout_steps_ancillaries_ski_transfer_title' }),
    [ServiceType.SkiCarriage]: intl.formatMessage({ id: 'checkout_steps_ancillaries_ski_carriage_title' }),
    [ServiceType.PartyTickets]: intl.formatMessage({ id: 'checkout_steps_ancillaries_party_tickets_title' }),
    [ServiceType.SkiPass]: intl.formatMessage({ id: 'checkout_steps_ancillaries_ski_pass_title' }),
    [ServiceType.SkiMaterial]: intl.formatMessage({ id: 'checkout_steps_ancillaries_ski_material_title' }),
    [ServiceType.SkiLesson]: intl.formatMessage({ id: 'checkout_steps_ancillaries_ski_lesson_title' }),
    [ServiceType.Sweater]: intl.formatMessage({ id: 'checkout_steps_clothing_sweater_title' }),
    [ServiceType.TShirt]: intl.formatMessage({ id: 'checkout_steps_clothing_tshirt_title' }),
    [ServiceType.Bus]: intl.formatMessage({ id: 'checkout_steps_ancillaries_bus_title' }),
    [ServiceType.Golf]: intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_title' }),
    [ServiceType.DinnerVouchers]: intl.formatMessage({ id: 'checkout_steps_ancillaries_dinner_vouchers_title' }),
    [ServiceType.Bridge]: intl.formatMessage({ id: 'checkout_steps_ancillaries_bridge_title' }),
    [ServiceType.ESim]: intl.formatMessage({ id: 'checkout_steps_ancillaries_esim_title' }),
    [ServiceType.BikeRental]: intl.formatMessage({ id: 'checkout_steps_ancillaries_bike_rental_title' }),
  };

  return serviceNames[type];
}
